import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { UserPlus, AlertCircle, CheckCircle } from 'lucide-react';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    company: '',
    phone: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { register } = useAuth();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const validateForm = () => {
    if (formData.password.length < 8) {
      setError('La password deve essere di almeno 8 caratteri');
      return false;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Le password non coincidono');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setError('');

    const result = await register({
      name: formData.name,
      email: formData.email,
      password: formData.password,
      company: formData.company,
      phone: formData.phone
    });

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '3rem 0', minHeight: '70vh' }}>
      <div className="container">
        <div className="form-container" style={{ maxWidth: '600px' }}>
          <h1 className="form-title">
            <UserPlus size={32} style={{ display: 'inline', marginRight: '0.5rem' }} />
            Registrati
          </h1>

          <div className="alert alert-info" style={{ marginBottom: '2rem' }}>
            <CheckCircle size={20} />
            Prova gratuita di 14 giorni. Nessuna carta richiesta.
          </div>

          {error && (
            <div className="alert alert-danger">
              <AlertCircle size={20} />
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Nome Completo *</label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Mario Rossi"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="tua@email.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="company">Azienda / Attività</label>
              <input
                type="text"
                id="company"
                name="company"
                className="form-control"
                value={formData.company}
                onChange={handleChange}
                placeholder="Nome della tua attività"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Telefono</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                className="form-control"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+39 333 1234567"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password *</label>
              <input
                type="password"
                id="password"
                name="password"
                className="form-control"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="Almeno 8 caratteri"
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Conferma Password *</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                className="form-control"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                placeholder="Ripeti la password"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              style={{ width: '100%', marginTop: '1rem' }}
            >
              {loading ? 'Registrazione in corso...' : 'Registrati'}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
            <p style={{ color: 'var(--gray)' }}>
              Hai già un account?{' '}
              <Link to="/login" style={{ color: 'var(--primary)', fontWeight: 600 }}>
                Accedi
              </Link>
            </p>
          </div>

          <div style={{ 
            marginTop: '2rem', 
            padding: '1rem', 
            background: 'var(--light-gray)', 
            borderRadius: '8px',
            fontSize: '0.875rem',
            color: 'var(--gray)'
          }}>
            Registrandoti accetti i nostri{' '}
            <Link to="/" style={{ color: 'var(--primary)' }}>Termini di Servizio</Link>
            {' '}e la{' '}
            <Link to="/" style={{ color: 'var(--primary)' }}>Privacy Policy</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
